// The improved version of the My Intrivity Application
import { html, css, LitElement } from 'lit-element';
import { unsafeHTML } from 'lit-html/directives/unsafe-html.js';
import { clone, cloneDeep } from 'lodash-es';
import { library, dom } from "@fortawesome/fontawesome-svg-core";   
 
import './badge.js';

import { doc, setDoc, getDoc, collection, addDoc, getFirestore } from "firebase/firestore";

import { db } from './intrivity_app.js';
import { 
    emitEvent, getScore, INTRIVITY_LOGOUT
} from './utility.js'
import { a11yStyles } from './a11y.js';
import { t, Localized } from './i18n.js';

// Display names for the profile fields this editor is used for.
const FIELD_LABELS = { image: 'profileField.image', organization: 'profileField.organization', title: 'profileField.title' };
const fieldLabel = (field) => (FIELD_LABELS[field] ? t(FIELD_LABELS[field]) : field);

export class UserProfileFieldEditorApp extends Localized(LitElement) {

    static get styles() {
        return [a11yStyles, css`
            .header {
                width: 100%;
                align-self: flex-end;
                display: grid;
                grid-template-columns: 1fr 5fr 1fr 1fr;
            }
            .user_edit {
                cursor: pointer;
                color: #424141;
                white-space: nowrap; 
                margin-left: 10px; 
                font-size: 0.8vmax;
                text-decoration: underline;
            }
        `];
    }
    
    static get properties() {
        return {
            show_value: { type: Boolean },
            user_profile: { type: Object },
            field: { type: String },
            value: { type: String },
            editing: { type: Boolean }
        };
    }

    constructor() {
        super();
        this.saveData = this.saveData.bind(this);
        this.editing = false;
        //this.show_value = true;
    }

    async saveData(e) {
            let payload = cloneDeep(this.user_profile);
            payload[this.field] = this.value;
            try {
                await setDoc(doc(db, "users", this.user_profile.email), payload, { merge: true });
                this.user_profile[this.field]=this.value;
                this.editing = false; 
                this.requestUpdate();
            } catch (x) {
                console.log(x);
                alert(t('profileField.saveError'));
            }        
    }
    
    render() {
        return html`
            ${this.editing ? html`
                <mwc-textfield style="width: 70%;" @change=${(e)=>{ 
                     this.value = e.target.value;
                    }} label="${fieldLabel(this.field)}" value=${this.value ? this.value: ''}></mwc-textfield>
                    <button type="button" @click=${this.saveData} class="unstyled-button user_edit">${t('profileField.save')}<span class="sr-only"> ${fieldLabel(this.field)}</span></button> 
                    <button type="button" @click=${(e)=>{ this.value = this.user_profile[this.field] ? this.user_profile[this.field]: ''; this.editing = false;}} class="unstyled-button user_edit">${t('profileField.cancel')}<span class="sr-only"> ${t('profileField.cancelEditing', { field: fieldLabel(this.field) })}</span></button>
            `: html`
                ${this.show_value ? html`${this.user_profile[this.field]}`: html``} 
                 <button type="button" @click=${(e)=>{ this.editing = true;}} class="unstyled-button user_edit">${t('profileField.edit', { field: fieldLabel(this.field) })}</button>
            `}
        `
    } 
 
}
if (!customElements.get('user-profile-field-editor')) customElements.define('user-profile-field-editor', UserProfileFieldEditorApp);
